import { render, staticRenderFns } from "./predictionleaderboard.vue?vue&type=template&id=c879fbb0&"
import script from "./predictionleaderboard.vue?vue&type=script&lang=js&"
export * from "./predictionleaderboard.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./predictionleaderboard.vue?vue&type=style&index=1&id=c879fbb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports